var _defs, _path, _polyline, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGrosimeTocWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "fdf94190-3c87-4b2d-8e43-e58efceca8a1",
    "data-name": "grosime_toc",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 199.07 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".af6f330d-1a8e-4d7a-8510-15eb7f7ee8ac,.b3b1ea6f-c644-4033-9156-b239ac8b6304{fill:none;stroke:#fff;stroke-linecap:round;stroke-linejoin:round;}.af6f330d-1a8e-4d7a-8510-15eb7f7ee8ac{stroke-width:10px;}.b3b1ea6f-c644-4033-9156-b239ac8b6304{stroke-width:5px;}.eed2dcc1-0758-4168-9184-c744166ff310{fill:#fff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "grosime_toc_white") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "af6f330d-1a8e-4d7a-8510-15eb7f7ee8ac",
    d: "M55,195",
    transform: "translate(-0.5)"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "af6f330d-1a8e-4d7a-8510-15eb7f7ee8ac",
    points: "54.5 5 54.5 195 144.5 195 144.5 30"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "b8183fe6-4500-4226-8af5-56a106fb4d34",
    "data-name": "Arrow copy"
  }, /*#__PURE__*/React.createElement("line", {
    className: "b3b1ea6f-c644-4033-9156-b239ac8b6304",
    x1: 2.5,
    y1: 115,
    x2: 44.36,
    y2: 115
  }), /*#__PURE__*/React.createElement("path", {
    className: "eed2dcc1-0758-4168-9184-c744166ff310",
    d: "M20.94,131.8a1.76,1.76,0,0,1,.53-2.42L44.06,115,21.47,100.62a1.75,1.75,0,0,1,1.88-3l24.91,15.86a1.76,1.76,0,0,1,0,3L23.35,132.34a1.75,1.75,0,0,1-2.41-.54Z",
    transform: "translate(-0.5)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "b3b1ea6f-c644-4033-9156-b239ac8b6304",
    x1: 196.57,
    y1: 115,
    x2: 154.71,
    y2: 115
  }), /*#__PURE__*/React.createElement("path", {
    className: "eed2dcc1-0758-4168-9184-c744166ff310",
    d: "M179.13,98.2a1.75,1.75,0,0,1-.54,2.42L156,115l22.58,14.38a1.75,1.75,0,0,1,.54,2.42,1.77,1.77,0,0,1-2.42.54l-24.9-15.86a1.76,1.76,0,0,1,0-3l24.9-15.86a1.79,1.79,0,0,1,.94-.27A1.77,1.77,0,0,1,179.13,98.2Z",
    transform: "translate(-0.5)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrosimeTocWhite);
export default __webpack_public_path__ + "static/media/grosime_toc_white.4b4cdd2ef89061090d35ec701aa94520.svg";
export { ForwardRef as ReactComponent };